export const GET_POLYGONS = "GET_POLYGONS";
export const CREATE_POLYGON = "CREATE_POLYGON";
export const CREATE_COORDINATES = "CREATE_COORDINATES";
export const DELETE_POLYGON = "DELETE_POLYGON";
